import {
  AxiosProxyConfig,
  ClientLogLevel,
  CreateClientParams,
} from 'contentful';

import { CustomAdapter } from './axios.types';

/** Interface that extends the base interface from contentful config */
export interface ICreateClientParams extends CreateClientParams {
  accessTokenPreview: string;
  isPreview?: boolean;
}

/**
 * Concrete implementation with static method to generate
 * and handle switching the access token and host url
 */
export class ContentfulClientParams implements ICreateClientParams {
  space!: string;
  accessToken!: string;
  accessTokenPreview!: string;
  environment?: string;
  insecure?: boolean;
  host?: string;
  basePath?: string;
  httpAgent?: any;
  httpsAgent?: any;
  proxy?: AxiosProxyConfig;
  headers?: any;
  adapter?: any;
  application?: string;
  integration?: string;
  resolveLinks?: boolean;
  removeUnresolved?: boolean;
  retryOnError?: boolean;
  logHandler?: (level: ClientLogLevel, data?: any) => void;
  timeout?: number;
  retryLimit?: number;
  isPreview?: boolean;

  constructor(config: ICreateClientParams) {
    Object.assign(this, config);
  }

  /**
   * Create a new instance of the ContentfulClientParams and
   * ensures it has the correct access token and host url.
   */
  static create(raw: ICreateClientParams, adapter?: CustomAdapter) {
    let config = new ContentfulClientParams(raw);
    if (adapter) {
      config = { ...config, adapter: adapter };
    }

    if (raw.isPreview) {
      config = {
        ...config,
        accessToken: config.accessTokenPreview,
        host: 'preview.contentful.com',
      };
    }
    return config;
  }
}
